import React from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Stack,
  Skeleton,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { MoneyFormatv2, MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useThemes } from "../../../components/Theme/theme";

const DataCard = ({ items, loading = true, backGroundColor,linearBackground,border_color }) => {
  const { theme } = useThemes();

  function formatAmount(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return "0";

  const num = Math.abs(Number(amount));

  if (num >= 10000000) {
    return  amount < 0 ?  -(num / 10000000).toFixed(2).replace(/\.00$/, '') + ' Cr' : (num / 10000000).toFixed(2).replace(/\.00$/, '') + ' Cr';
  } else if (num >= 100000) {
    return  amount < 0 ? -(num / 100000).toFixed(2).replace(/\.00$/, '') + ' L' : (num / 100000).toFixed(2).replace(/\.00$/, '') + ' L';
  } else if (num >= 1000) {
    return amount < 0 ? -(num / 1000).toFixed(2).replace(/\.00$/, '') + ' K' : (num / 1000).toFixed(2).replace(/\.00$/, '') + ' K';
  } else {
    return amount < 0 ? -(num).toFixed(2) : num.toFixed(2);
  }
}

  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        // aspectRatio: "11/5",
        border:"solid 2px",
        borderColor:border_color,
        height: "100%",
        padding: 0,
        margin: 0,
        borderRadius:"10px",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          padding: 1,
          margin: 0,
          "&:last-child": {
            paddingBottom: 1,
          },
        }}
      >
        <Stack spacing={{xs:0.5,sm:1}}>
          {items.map((item, index) => {
            const {
              key,
              title,
              current,
              previous,
              percentageChange,
              isPositive,
              currentLoss,
              previousLoss,
            } = item;

            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "space-between",
                  
                }}
              >
                <Box>
                  <Typography
                    variant="h2"
                    // fontWeight="bold"
                    sx={{
                      fontSize: { xs: "14px", sm: "13px" },
                      textWrap: "nowrap",
                      display: "flex",
                      alignItems: "baseline",
                    }}
                  >
                    {title}
                    {((key === "grossProfit" && (previousLoss || currentLoss)) || (key === "netProfit" && (previousLoss || currentLoss))) && (
                      <Typography
                        component="span"
                        variant="h2"
                        fontWeight="bold"
                        sx={{
                          fontSize: { xs: "14px", sm: "15px" },
                          textWrap: "nowrap",
                          color: "#ed2f3f",
                          ml: 0.5,
                        }}
                      >
                        (Loss)
                      </Typography>
                    )}
                  </Typography>

                  <Stack direction="row" spacing={1} >
                    {loading ? (
                      <Skeleton width={50} variant="text" animation="wave" />
                    ) : (
                      <Typography
                        variant="subtitle2"
                        color={previousLoss ? "#ed2f3f" : "#824487"}
                        sx={{
                          fontSize: "16px",
                          fontWeight: 900,
                          textWrap: "nowrap",
                        }}
                      >
                        ₹ {formatAmount(previous)}
                      </Typography>
                    )}

                    <Typography variant="subtitle2" sx={{marginTop:{sm:"2px !important",xs:"0px !important"}}}>vs</Typography>

                    {loading ? (
                      <Skeleton variant="text" width={50} animation="wave" />
                    ) : (
                      <Typography
                        variant="subtitle2"
                        color={currentLoss ? "#ed2f3f" : "#0356fc"}
                        sx={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          textWrap: "nowrap",
                        }}
                      >
                        ₹ {formatAmount(current)}
                      </Typography>
                    )}
                  </Stack>
                </Box>

                <Box display="flex" alignItems="end">
                  <Typography
                    variant="subtitle2"
                    fontSize="12px"
                    marginLeft={1}
                    sx={{ textWrap: "nowrap" }}
                  >
                    {isPositive ? "+" : "-"}
                    {percentageChange}%
                  </Typography>
                  {isPositive ? (
                    <ArrowUpward sx={{ color: "#0c7825ff" }} fontSize="small" />
                  ) : (
                    <ArrowDownward sx={{ color: "#f5502f" }} fontSize="small" />
                  )}
                </Box>
              </Box>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default DataCard;
